import { Component, OnInit } from '@angular/core';
import { IAslibModalOptions } from '@aslib/modal';
import { AslibGridComponent } from '@aslib/components';
import { BaseComponentService } from '../../services/base-component.service';

@Component({
  selector: 'gpa-pedido',
  templateUrl: './pedido.component.html',
  providers: [BaseComponentService],
  styles: [
    `
      .fieldRow {
      height:1px; border:none; color:#000; background-color:#000; margin-top: 0px; margin-bottom: 0px;'
      }
  `
  ]
})

export class PedidoComponent extends BaseComponentService implements OnInit {

  data: any;
  dataCadInfoPagto: string;
  horasCadInfoPagto: any[];
  horaCadInfoPagto: string;
  desabilitarEnviar:boolean;
  desabilitarCarregar: boolean;
  projetoIntegrado: string;
  showTabsNavigation = false;

  ngOnInit() {
    this.lista = [];
    this.dataCadInfoPagto = '';
    this.horasCadInfoPagto = [];
    this.horaCadInfoPagto = '';
    this.desabilitarEnviar = true;
    this.desabilitarCarregar = true;

    this.projetoIntegrado = sessionStorage.getItem('ProjetoIntegrado');
  }

  enviarPED(grid:AslibGridComponent) {
    if (this.lista.length === 0) {
      this.exibirAviso('Não há dados para a geração e envio do PED.');
      return;
    }

    this.aslibLoadingService.start();

    this._service.routePrefix = '/api/PedEnvio';
    this.subSave = this._service.add(this.lista,'gpa').subscribe(data => {
        this.desabilitarEnviar = true;

        // atualiza a coluna de sinalização de envio.
        for (let index = 0; index < this.lista.length; index++) {
          this.lista[index].enviadoNoPED = true;
        }

        this.exibirSucesso('Os PEDs foram enviados com sucesso.');
      },
      erro => {
        this.aslibLoadingService.complete();
        this.exibirErro(erro);
      },
      () => {
          this.aslibLoadingService.complete();
      }
    );
  }

  horaCadInfoPagtoChange() {
    this.desabilitarCarregar = this.horaCadInfoPagto === '';
  }

  limpar(grid: AslibGridComponent){
    this.horaCadInfoPagto = '';
    this.horasCadInfoPagto = [];
    this.lista = [];
    this.desabilitarCarregar = true;
    grid.dataset = null;
  }

  async getHorasInfoPagto() {
    this.showTabsNavigation = false;
    if (this.isNullOrUndefinedOrEmpty(this.dataCadInfoPagto)) {
      this.exibirAviso('Favor informar uma data para consulta dos dados carregados.');
      return;
    }

    this.aslibLoadingService.start();

    try {
      await this.preencheComboDoisParametros(
        '/api/InformacaoPagamento/ObterHorariosCadInfoPagamento/', 'horasCadInfoPagto',
        this.projetoIntegrado, this.dataCadInfoPagto,'gpa');

        this.aslibLoadingService.complete();

      if (!this.horasCadInfoPagto || this.horasCadInfoPagto.length == 0) {
          this.exibirAviso('Não foram encontrados dados carregados para a data informada.');
      } else {
        // exclui a opção "Todos".
        for (let index = 0; index < this.horasCadInfoPagto.length; index++) {
          if (this.horasCadInfoPagto[index].toUpperCase() === 'TODOS') {
            this.horasCadInfoPagto.splice(index,1);
          }
        }
      }
    } catch (error) {
      this.aslibLoadingService.complete();
      this.exibirErro(error);
    }

    this.aslibLoadingService.complete();
  }

  getInfoPagto(grid: AslibGridComponent): void {

    let hora = this.horaCadInfoPagto.substring(this.horaCadInfoPagto.length-5, this.horaCadInfoPagto.length);
    if(hora.toUpperCase() !=='TODOS' ){
       hora = hora.replace(':', '-');
    }

    const rota = '/api/InformacaoPagamento/ObterInfoPagamento';
    this._service.routePrefix = rota.concat(`/${this.projetoIntegrado}/${this.dataCadInfoPagto}/${hora}`);

    this.desabilitarEnviar = true;

    this.aslibLoadingService.start();

    this.subListar = this._service.getAll('gpa').subscribe(data => {

        this.lista = data;
        this.showTabsNavigation = true;
        this.desabilitarEnviar = this.lista.length > 0 && this.lista[0].enviadoNoPED === true;
      },
      (error) => {
        this.aslibLoadingService.complete();
        this.exibirErro(error);
      },
      () => {
        this.aslibLoadingService.complete();
      }
    );
  }

  openModalParametros(conteudo: any) {
    const options: IAslibModalOptions = {
      title: 'Parâmetros de Pagamento',
      backdrop: 'static',
      cancelarVisible: false,
      size: 'lg',
      content: conteudo
    };

    // Carrega um modal para exibição de mansagem
    this.aslibModal.open(options).result.then(
      () => { },
      () => { }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pagamento/pedido/pedido.component.ts